import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { ClinicHeader } from '../ClinicHeader';
import PatientDetailsHeader from '../PatientDetailsHeader';
import { ReportFooterTimestamp, tableCellStyle } from '../../../utils/reportUtils';
import { Diagnosis } from '../../../pages/Registration/NewRegistration/PatientPartnerRegistration/PatientReport/reportHelper';

interface Props {
  diagnoses: Diagnosis[];
}

const DiagnosisReport: React.FC<Props> = ({ diagnoses }) => {
  const { t: tGeneral } = useTranslation('general');
  const { t: tInvestigation } = useTranslation('investigation_config');
  return (
    <Box sx={{ p: 5, backgroundColor: '#fff', color: '#333', fontFamily: 'Arial, sans-serif' }}>
      <ClinicHeader />
      <PatientDetailsHeader />
      <Box component="hr" sx={{ my: 3, borderColor: '#ccc' }} />
      <Typography variant="h6" sx={{ mb: 1, color: '#444' }}>{tGeneral('diagnosis_Report')}</Typography>
      <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {[
                '#',
                tInvestigation('DiagnosisCode'),
                tInvestigation('DiagnosisName'),
                tInvestigation('DiagnosisType'),
                tInvestigation('Doctor'),
                tInvestigation('Note')
              ].map((heading, i) => (
                <TableCell key={i} sx={{ ...tableCellStyle, fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>          

          <TableBody>
            {diagnoses.map((diag, i) => (
              <TableRow key={diag.id}>
                <TableCell sx={tableCellStyle}>{i + 1}</TableCell>
                <TableCell sx={tableCellStyle}>{diag.diagnosis_code}</TableCell>
                <TableCell sx={tableCellStyle}>{diag.diagnosis_name}</TableCell>
                <TableCell sx={tableCellStyle}>{diag.diagnosis_type_label}</TableCell>
                <TableCell sx={tableCellStyle}>{diag.doctor_name ?? '-'}</TableCell>
                <TableCell sx={tableCellStyle}>{diag.notes ?? '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <ReportFooterTimestamp />
    </Box>
  );
};

export default DiagnosisReport;
